<style>
.promoterHeader1 {
  width: 100%;
  height: 3.25rem;
}
.bg-color-red1 {
  background-color: #e93323 !important;
  background: url(/h5/img/user_bg.f37fd1a5.jpg) no-repeat;
  background-size: 107%;
}
.promoterHeader1 .headerConp {
  width: 100%;
  padding: 0.4rem 0.88rem 0 0.55rem;
  font-size: 0.3rem;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.promoterHeader1 .headerConp .name {
  margin-bottom: 0.1rem;
  font-weight: bold;
  letter-spacing: 2px;
}
.promoterHeader1 .headerConp .num {
  font-size: 0.7rem;
  letter-spacing: 2px;
  font-weight: bold;
}
.wrapper1 {
  width: 6.6rem;
  background-color: #f8f4f4;
  border-radius: 0.7rem;
  margin: 0.3rem auto 0 auto;
  box-shadow: 0px 0px 20px 0px rgb(249, 112, 104);
}
.wrapper1 .navr {
  height: 6rem;
}
.wrapper1 .navr .list1 {
  padding: 0 0.3rem;
  width: 100%;
  font-size: 0.9375rem;
  color: #676565;
  border-bottom: 1px solid #cfcacb;
}
.promoter-list1 .list1 .shuru {
  background-color: #f8f4f4;
  border-bottom: 1.5px solid #c6b9b9;
  height: 1.32rem;
  padding: 0 0.3rem 0 0.2rem;
  font-size: 0.8rem;
  color: #666;
}
.wrapper1 .navr .navrg {
  padding: 0.6rem 0.88rem 0.2rem 0.55rem;
  font-size: 0.35rem;
  color: #808080;
  letter-spacing: 2px;
  font-weight: 600;
}
.wrapper1 .navr .tixian {
  width: 4.2rem;
  font-size: 0.34rem;
  color: #fff;
  height: 0.66rem;
  border-radius: 0.43rem;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#fb8561),
    to(#fb8561)
  );
  background: linear-gradient(to right, #fb8561 0%, #fb8561 100%);
  background: -moz-linear-gradient(to right, #fb8561 0%, #fb8561 100%);
  text-align: center;
  line-height: 0.66rem;
  letter-spacing: 5px;
  margin-left: 19%;
  margin-top: 11%;
}
.shuoming {
  padding: 0.6rem 0.88rem 0.2rem 0.55rem;
}
.shuoming .cashshuoming {
  font-size: 0.35rem;
  color: #555353;
  letter-spacing: 2px;
  font-weight: bolder;
  padding: 0.2rem;
}
.shuoming .pshuoming {
  font-size: 0.25rem;
  color: #555353;
  letter-spacing: 2px;
  padding: 0.1rem;
}
</style>
<template>
  <div class="promoter-list1" ref="container">
    <div class="promoterHeader1 bg-color-red1">
      <div class="headerConp acea-row row-between-wrapper">
        <div>
          <div class="name">可提现金额(元)</div>
          <div>
            <span class="num">{{ keTi.money || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="wrapper1">
        <div class="navr">
          <div class="navrg">提现金额</div>
          <div class="list1">
            ￥
            <input style="font-size: 0.8rem;width: 70%;" v-model="keTi.money" disabled />
          </div>
          <div class="navrg">最低￥{{ configk.zuidi || 0 }}可提现</div>

          <p v-if="userInfo.txopenid ===''">
            <a
              href="http://wx.szsmile.cn/plug/Oauth/Test_OpenID.asp?url=http://yd.top917.cn/user/user_cash"
            >
              <div class="tixian">绑定提现信息</div>
            </a>
          </p>

          <div class="tixian" @click="submitted" v-else>立即提现</div>
        </div>
      </div>
      <div class="shuoming">
        <scan style="border-right: 4px solid #f11b09;font-size: 0.5rem;"></scan>
        <scan class="cashshuoming">提现说明:</scan>
        <p class="pshuoming">1.默认全额提现；</p>
        <p class="pshuoming">2.单笔提现金额5000元以内，请及时提现；</p>
        <p class="pshuoming">3.提现后T+1到账至微信零钱；</p>
        <p class="pshuoming">4.一旦发现任何违规行为，平台有权终止提现，并对您暂时或永久封号。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getUser } from "@api/user";
import { postMyTixian, getUserKeti, getConfigk, stxopenid } from "@api/yongjin";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";

export default {
  name: "UserCash",
  components: {},
  props: {},
  data: function() {
    return {
      userInfo: {},
      post: {
        money: ""
      },
      keTi: {},
      configk: {}
    };
  },

  mounted: function() {
    this.User();
    this.getMoney();
    this.getConfigk();
    this.getQueryVariable("openid");
  },
  methods: {
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },

    getMoney: function() {
      let that = this;
      getUserKeti().then(
        res => {
          that.keTi = res.data;
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    getConfigk: function() {
      let that = this;
      getConfigk().then(
        res => {
          that.configk = res.data;
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },

    async submitted() {
      let money = this.keTi.money.toString(),
        that = this;
      if (parseFloat(money) < parseFloat(that.configk.zuidi))
        return that.$dialog.message("最低提现金额" + that.configk.zuidi);
      if (parseFloat(money) > 5000)
        return that.$dialog.message("单笔提现金额不能超过5000");
      await this.$validator({
        money: [required(required.message("提现金额"))]
      }).validate({ money });
      let save = {
        money: money
      };
      that.save(save);
    },
    save: function(info) {
      postMyTixian(info).then(
        res => {
          //this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/audit" });
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    },
    getQueryVariable: function(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("?");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          var txopenid = pair[1];
          stxopenid({
            txopenid: txopenid
          }).then(
            res => {
              this.$dialog.message(res.msg);
              window.location.href = "/user/user_cash";
            },
            error => {
              this.$dialog.message(error.msg);
            }
          );
        }
      }
      return false;
    }
  }
};
</script>
